export function estraiMaiuscole(str: string): string {
    let maiuscole: string = "";
    for (let i = 0; i < str.length; i++) {
        if (str[i] === str[i].toUpperCase() && str[i] !== str[i].toLowerCase()) {
            maiuscole += str[i];
        }
    }
    return maiuscole;
}